<template>
  <v-dialog v-model="dialog" width="400" persistent>
    <v-card>
      <v-form @submit.prevent="submit">
        <v-card-title>
          Filtros avançados
          <v-spacer></v-spacer>
          <v-btn @click="close()" icon>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-text-field
            type="number"
            label="Último pagamento (dias)"
            v-model="form.ultimo_pagamento"
            filled
            dense
            clearable
          ></v-text-field>

          <MoneyInput
            label="Débito mínimo"
            v-model="form.debito"
            filled
            dense
            clearable
          ></MoneyInput>
        </v-card-text>

        <v-card-actions>
          <v-btn type="submit" color="primary" block>Aplicar</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import MoneyInput from "@/components/MoneyInput.vue";

export default {
  components: {
    MoneyInput
  },

  data() {
    return {
      dialog: false,
      form: {}
    };
  },

  methods: {
    open(initial = {}) {
      this.dialog = true;
      this.form = {
        ...initial
      };
    },
    close() {
      this.dialog = false;
    },
    submit() {
      this.$emit("submit", this.form);
    }
  }
};
</script>
